# frozen_string_literal: true

module Engine
  module Game
    module GRollingStockStars
    end
  end
end
